import Config from "../_config/config";
import myAxios from "./axiositeachWrapper";

const BASE = `${Config.nodeSiteUrl}v1/credentials`;

class CredentialService {
  // ── Signing Keys ──
  generateKeys = (schoolId?: number) =>
    myAxios.post<any>(`${BASE}/admin/generate-keys`, schoolId ? { schoolId } : {});
  listKeys = (schoolId?: number) =>
    myAxios.get<any>(`${BASE}/admin/keys`, schoolId ? { params: { schoolId } } : {});
  listSchools = () => myAxios.get<any>(`${BASE}/admin/schools`);

  // ── Issuer Domain ──
  getIssuerDomain = () => myAxios.get<any>(`${BASE}/admin/issuer-domain`);
  setIssuerDomain = (customIssuerDomain: string | null) =>
    myAxios.put<any>(`${BASE}/admin/issuer-domain`, { customIssuerDomain });

  // ── Badge Image Library + Custom Upload ──
  getBadgeLibraryUrl = () =>
    myAxios.get<any>(`${BASE}/admin/badge-library`);
  uploadBadgeImage = (file: File, badgeDefinitionId?: number) => {
    const form = new FormData();
    form.append("file", file);
    if (badgeDefinitionId) form.append("badgeDefinitionId", String(badgeDefinitionId));
    return myAxios.post<any>(`${BASE}/admin/badge-definitions/upload-image`, form, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  };

  // ── Badge Definitions ──
  listBadgeDefinitions = () => myAxios.get<any>(`${BASE}/admin/badge-definitions`);
  getBadgeDefinition = (id: number) =>
    myAxios.get<any>(`${BASE}/admin/badge-definitions/${id}`);
  createBadgeDefinition = (body: {
    name: string;
    description?: string;
    criteriaText?: string;
    criteriaUrl?: string;
    imagePath?: string;
    certificateId?: number;
    achievementType?: string;
    expiryDurationDays?: number;
    ctaUrl?: string;
    ctaText?: string;
    verifyTemplate?: string;
    crossSellLinks?: { label: string; url: string; imageUrl?: string; description?: string }[];
  }) => myAxios.post<any>(`${BASE}/admin/badge-definitions`, body);
  updateBadgeDefinition = (
    id: number,
    body: {
      name: string;
      description?: string;
      criteriaText?: string;
      criteriaUrl?: string;
      imagePath?: string;
      certificateId?: number;
      achievementType?: string;
      expiryDurationDays?: number;
      ctaUrl?: string;
      ctaText?: string;
      verifyTemplate?: string;
      crossSellLinks?: { label: string; url: string; imageUrl?: string; description?: string }[];
    },
  ) => myAxios.put<any>(`${BASE}/admin/badge-definitions/${id}`, body);
  deleteBadgeDefinition = (id: number) =>
    myAxios.delete<any>(`${BASE}/admin/badge-definitions/${id}`);

  // ── Admin Issue ──
  searchStudents = (search: string) =>
    myAxios.get<any>(`${BASE}/admin/search-students`, { params: { search } });
  adminIssueCredential = (body: { badgeDefinitionId: number; enquiryId: number }) =>
    myAxios.post<any>(`${BASE}/admin/issue`, body);
  adminIssueCertificate = (body: {
    certificateId: number;
    enquiryId: number;
    courseName?: string;
    completionDate?: string;
    expiryDate?: string;
  }) => myAxios.post<any>(`${BASE}/admin/issue-certificate`, body);
  listIssuedCredentials = (page: number = 1, limit: number = 20) =>
    myAxios.get<any>(`${BASE}/admin/issued`, { params: { page, limit } });

  // ── Certificate Templates ──
  listCertificateTemplates = () =>
    myAxios.get<any>(`${BASE}/admin/certificate-templates`);
  previewTemplate = (id: number) =>
    myAxios.get<any>(`${BASE}/admin/certificate-templates/${id}/preview`, { responseType: "text" });
  createTemplate = (body: { name: string; content: string; category?: string; remarks?: string }) =>
    myAxios.post<any>(`${BASE}/admin/certificate-templates`, body);
  updateTemplate = (id: number, body: { name?: string; content?: string; category?: string; remarks?: string }) =>
    myAxios.put<any>(`${BASE}/admin/certificate-templates/${id}`, body);
  duplicateTemplate = (id: number) =>
    myAxios.post<any>(`${BASE}/admin/certificate-templates/${id}/duplicate`);
  seedTemplates = () =>
    myAxios.post<any>(`${BASE}/admin/certificate-templates/seed`);

  // ── Badge Eligibility (polymorphic scopes) ──
  getBadgeEligibility = (badgeId: number) =>
    myAxios.get<any>(`${BASE}/admin/badge-definitions/${badgeId}/eligibility`);
  saveBadgeEligibility = (
    badgeId: number,
    scopes: Array<{ scopeType: "lesson_plan" | "course" | "program"; scopeId: number }>,
  ) => myAxios.put<any>(`${BASE}/admin/badge-definitions/${badgeId}/eligibility`, { scopes });
  searchEligibilityScope = (scope: "lesson_plan" | "course" | "program", q: string) =>
    myAxios.get<any>(`${BASE}/scope-search`, { params: { scope, q } });

  // ── Attendance Badge ──
  searchCoursesForBadge = (search: string) =>
    myAxios.get<any>(`${BASE}/admin/attendance-badge/search-courses`, { params: { search } });
  getAttendanceBadgeEligible = (courseId: number) =>
    myAxios.get<any>(`${BASE}/admin/attendance-badge/eligible`, { params: { courseId } });
  issueAttendanceBadges = (courseId: number) =>
    myAxios.post<any>(`${BASE}/admin/attendance-badge/issue`, { courseId });
}

export default new CredentialService();
